import React, { Fragment, useState, useEffect } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

import { getProfileById } from "../../actions/profile";
import { jobChatMessage, deleteChatMessage } from "../../actions/stream";

import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import LoggedOutNav from "../layout/IME/LoggedOutNav";
import TwoFARequest from "../layout/Innovators/TwoFARequest";
import OnlineUsers from "../layout/IME/OnlineUsers";
import RecommendedUsers from "../layout/IME/RecommendedUsers";
import JobLiveVideo from "../layout/Employers/JobLiveVideo";
import StreamChatBlue from "../layout/Employers/StreamChatBlue";
import ReportUser from "../layout/IME/ReportUser";
import StreamSecondaryLogo from "../layout/IME/StreamSecondaryLogo";
import JobPostApply from "../layout/Employers/JobPostApply";

let socket;

const JobStream = ({
  match,
  auth: { user, channelid, jobtitle, location, verified },
  profile: { profile },
  getProfileById,
  jobChatMessage,
  deleteChatMessage,
  isAuthenticated,
}) => {
  const ENDPOINT = "localhost:5000";

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [room, setRoom] = useState(match.params.channelid);
  const [imeBotAvi, setimebotavi] = useState("Innovate_Me_logo_blue.png");
  const [showChat, setShowChat] = useState(true);
  const [showJob, setShowJob] = useState(false);
  const [showAuthentication, setShowAuthentication] = useState(true);

  const maxLength = 100;

  const deleteMessage = (id, message) => {
    deleteChatMessage(match.params.channelid, message);
    const removeIndex = messages
      .map((deletedMessage) => deletedMessage.messageid)
      .indexOf(id);

    messages.splice(removeIndex, 1);

    setMessages([...messages]);
  };

  useEffect(() => {
    setRoom(match.params.channelid);
  }, [match.params.channelid, room]);

  useEffect(() => {
    getProfileById(match.params.channelid);
  }, [getProfileById, match.params]);

  useEffect(() => {
    if (user) {
      socket = io(ENDPOINT);

      socket.on("roomUsers", (room, users) => {
        console.log(room, users);
      });

      socket.emit("joinRoom", {
        imebotavi: imeBotAvi,
        channelid: user.channelid,
        avatar: user.avatar,
        firstname: user.firstname,
        lastname: user.lastname,
        room: match.params.channelid,
      });
    }

    return () => {
      if (socket) {
        socket.emit("leave");

        socket.on("roomUsers", (users) => {
          // setViewerCount([...users.users]);
        });

        socket.disconnect();

        socket.off();
      }
    };
  }, [ENDPOINT, match.params.channelid, user]);

  useEffect(() => {
    socket.on("message", (message) => {
      setMessages([...messages, message]);
    });
  }, [messages]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (message) {
      jobChatMessage(match.params.channelid, message);
      socket.emit(
        "chatMessage",
        message,
        user.firstname,
        user.lastname,
        user.avatar,
        room
      );
      setMessage("");
    }
  };

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {/* <ReportUser /> */}
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {isAuthenticated && <LoggedInNavBlue />}
      {!isAuthenticated && <LoggedOutNav />}
      {showJob && <JobPostApply setShowJob={setShowJob} />}
      <div className={showChat ? "flex-only-alt" : "flex-no-chat"}>
        <div className="side-container border-right grey">
          {isAuthenticated && <OnlineUsers />}
          {!isAuthenticated && <RecommendedUsers />}
        </div>
        <div className="main-stream-content">
          <div className="video-chat">
            <JobLiveVideo showChat={showChat} profile={profile} />
            {!showChat && (
              <div className="showchaticon" onClick={() => setShowChat(true)}>
                <i className="far fa-comment fa-2x blue"></i>
              </div>
            )}
          </div>
          <div className="stream-information-container">
            <div className="stream-info-grid">
              <div className="stream-grid-container">
                <div className="stream-info">
                  <img
                    // src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/employer.png`}
                    className="streamer-user-avi"
                  />
                  <div className="helper-container">
                    <p className="stream-description">
                      Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                      Nam ratione aut eaque dolor ea temporibus laboriosam
                      laborum recusandae odio omnis.
                    </p>
                    <div className="stream-lower-info">
                      <ul className="creator-stream-items">
                        <li className="stream-item blue">
                          {profile.companyname}
                        </li>
                        <li className="stream-item blue">
                          {profile.channelid}
                        </li>
                        <li className="stream-item">
                          {profile.firstname} {profile.lastname}
                        </li>
                        {/* <li className="stream-item">
                          {profile.location && profile.location.city},{" "}
                          {profile.location && profile.location.state}
                        </li> */}
                        <li className="stream-item">
                          <i className="far fa-clock mr-5 blue"></i>
                          Date
                        </li>
                      </ul>
                      <ul className="user-count-items">
                        <li className="user-count-item">
                          <i className="fas fa-check fa-lg mr-5 blue"></i>
                          <span className="blue mr-5 bold">Followers</span>
                          <span className="white bold">5,852</span>
                        </li>
                      </ul>
                      <div className="action-buttons">
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button blue">
                              <i className="far fa-thumbs-up action-icon fa-lg"></i>
                            </div>
                            <p className="action-text">5,768</p>
                          </div>
                        )}
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button blue">
                              <i className="far fa-thumbs-down action-icon fa-lg"></i>
                            </div>
                          </div>
                        )}
                        <div className="action-items-stream">
                          <div className="action-button blue">
                            <i className="far fa-user action-icon-alt-two fa-lg"></i>
                          </div>
                          <p className="action-text">5,768</p>
                        </div>
                        {isAuthenticated && (
                          <div className="action-items-stream">
                            <div className="action-button blue">
                              <i className="far fa-share-square action-icon fa-lg"></i>
                            </div>
                            <p className="action-text">Share</p>
                          </div>
                        )}
                        {isAuthenticated &&
                          user.channelid !== profile.channelid && (
                            <div className="action-items-stream">
                              <div className="action-button blue">
                                <i className="fas fa-check action-icon fa-lg"></i>
                              </div>
                              <p className="action-text">Follow</p>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="stream-grid-container-alt">
                {isAuthenticated && (
                  <div
                    className="action-items-stream-alt"
                    onClick={(e) => setShowJob(true)}
                  >
                    <div className="action-button blue">
                      <i className="fas fa-file-alt file-action-icon fa-lg"></i>
                    </div>
                    <p className="action-text">Apply</p>
                  </div>
                )}
                <div className="action-items-stream-alt">
                  <div className="action-button blue">
                    <i className="fas fa-street-view fa-lg vr-action-icon fa-lg"></i>
                  </div>
                  <p className="action-text">VR Tour</p>
                </div>
                <StreamSecondaryLogo />
              </div>
            </div>
          </div>
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt blue">
                  <p className="online-title-alt blue">Software Engineer</p>
                </div>
              </div>
              <ul className="stream-container-items-alt">
                <li className="stream-container-item">
                  Applicants
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  24
                </li>
                <li className="stream-container-item">
                  Work Environment
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Agile
                </li>
                <li className="stream-container-item">
                  Job Variation Rating (1-10)
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>8
                </li>
                <li className="stream-container-item">
                  Innovative Employer
                  <i className="fas fa-award mx-5 blue"></i>
                </li>
                <li className="stream-container-item">
                  <i className="far fa-clock mx-5 blue"></i>
                  Job Post created on{" "}
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>{" "}
                  05/27/2020
                </li>
              </ul>
              <p className="stream-desc-paragraph">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
                asperiores, rem autem consectetur minus sit, in consequuntur
                magnam alias, temporibus voluptatum reiciendis omnis ab earum
                modi laudantium ex velit eaque?Ratione labore voluptate sunt
                odit, neque illum iste corporis quaerat laudantium voluptates
                aliquid voluptas minima ducimus nam blanditiis expedita mollitia
                vero accusamus distinctio! Debitis molestias eos doloremque
                officiis quibusdam mollitia!
              </p>
              <ul className="stream-container-items">
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Troubleshoot complicated, distributed problems in a software
                  system
                </li>
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Use of HTML, Javascript and CSS for modern browsers such as
                  Chrome, Firefox and IE
                </li>
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Working and Understanding browser compatibility issues and
                  Responsive web design
                </li>
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Translation of functional requirements and high-level design
                  of components and modules into a developed and tested,
                  multi-tier solution, including user interface, business logic
                  and database
                </li>
              </ul>
              <ul className="stream-container-items">
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Bachelor's degree in Computer Science, or related area or
                  similar industry certification or experience
                </li>
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Experience with architectural design of large-scale, highly
                  reliable, and highly available internet facing application
                  using best in breed enterprise toolsets like Java, J2EE or
                  Microsoft .NET
                </li>
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Experience implementing and supporting database persistence
                  strategies in enterprise level database technologies like
                  Oracle, SQL Server, PostGreSQL, or MSQL
                </li>
                <li className="stream-container-item">
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Experience working in or desire to work in an Agile
                  environment (Scrum/XP/Kanban)
                </li>
              </ul>
            </div>
          </div>
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt blue">
                  <p className="online-title-alt blue">Chat Rules</p>
                </div>
              </div>
              <ul className="stream-container-items">
                <li className="stream-container-item">
                  Be Respectful
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  No racism, homophobic comments, profanity, bullying or any
                  acts of hate and / or descrimination
                </li>
                <li className="stream-container-item">
                  Spamming
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  No links to any content, unless approved by channel employer
                </li>
                <li className="stream-container-item">
                  Live Link Requests
                  <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                  Live Link Requests will only be permitted towards the end of
                  the stream. I will try to link as many requests as I can
                </li>
              </ul>
            </div>
          </div>
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt blue">
                  <p className="online-title-alt blue">About Company</p>
                </div>
              </div>
              <p className="stream-desc-paragraph">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid
                asperiores, rem autem consectetur minus sit, in consequuntur
                magnam alias, temporibus voluptatum reiciendis omnis ab earum
                modi laudantium ex velit eaque?Ratione labore voluptate sunt
                odit, neque illum iste corporis quaerat laudantium voluptates
                aliquid voluptas minima ducimus nam blanditiis expedita mollitia
                vero accusamus distinctio! Debitis molestias eos doloremque
                officiis quibusdam mollitia!
              </p>
            </div>
          </div>
          {(profile.sociallinks && profile.sociallinks.youtube !== "") ||
            (profile.sociallinks && profile.sociallinks.tiktok !== "") ||
            (profile.sociallinks && profile.sociallinks.discord !== "") ||
            (profile.sociallinks && profile.sociallinks.facebook !== "") ||
            (profile.sociallinks && profile.sociallinks.twitter !== "") ||
            (profile.sociallinks && profile.sociallinks.instagram !== "") ||
            (profile.sociallinks && profile.sociallinks.snapchat !== "" && (
              <div className="stream-section-container">
                <div className="padding-container">
                  <div className="title-container-info">
                    <div className="border-alt blue">
                      <p className="online-title-alt blue">Social Media</p>
                    </div>
                  </div>
                  <div className="social-media-content">
                    <ul className="stream-container-items-alt">
                      {profile.sociallinks &&
                        profile.sociallinks.youtube !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-youtube fa-lg blue mx-5"></i>
                            YouTube
                            <i className="fas fa-long-arrow-alt-right fa-lg blue mx-5"></i>
                            {profile.sociallinks.youtube}
                          </li>
                        )}
                      {profile.sociallinks &&
                        profile.sociallinks.tiktok !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-tiktok fa-lg blue mx-5"></i>
                            TikTok
                            <i className="fas fa-long-arrow-alt-right fa-lg blue mx-5"></i>
                            {profile.sociallinks.tiktok}
                          </li>
                        )}
                      {profile.sociallinks &&
                        profile.sociallinks.discord !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-discord fa-lg blue mx-5"></i>
                            TikTok
                            <i className="fas fa-long-arrow-alt-right fa-lg blue mx-5"></i>
                            {profile.sociallinks.discord}
                          </li>
                        )}
                      {profile.sociallinks &&
                        profile.sociallinks.instagram !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-instagram fa-lg blue mx-5"></i>
                            Instagram
                            <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                            {profile.sociallinks.instagram}
                          </li>
                        )}
                      {profile.sociallinks &&
                        profile.sociallinks.facebook !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-facebook-square fa-lg blue mx-5"></i>
                            Facebook
                            <i className="fas fa-long-arrow-alt-right fa-lg blue mx-5"></i>
                            {profile.sociallinks.facebook}
                          </li>
                        )}
                      {profile.sociallinks &&
                        profile.sociallinks.twitter !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-twitter-square fa-lg blue mx-5"></i>
                            Twitter
                            <i className="fas fa-long-arrow-alt-right fa-lg blue mx-5"></i>
                            {profile.sociallinks.twitter}
                          </li>
                        )}
                      {profile.sociallinks &&
                        profile.sociallinks.snapchat !== "" && (
                          <li className="stream-container-item">
                            <i className="fab fa-snapchat-ghost fa-lg blue mx-5"></i>
                            Snapchat
                            <i className="fas fa-long-arrow-alt-right blue mx-5"></i>
                            {profile.sociallinks.snapchat}
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          <div className="stream-section-container">
            <div className="padding-container">
              <div className="title-container-info">
                <div className="border-alt blue">
                  <p className="online-title-alt blue">Approved Mentors</p>
                </div>
              </div>
              <div className="sponsors-container">
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
                <div className="sponsor"></div>
              </div>
            </div>
          </div>
          <div className="margin-top"></div>
        </div>
        {showChat && (
          <StreamChatBlue
            messages={messages}
            message={message}
            setMessage={setMessage}
            sendMessage={sendMessage}
            deleteMessage={deleteMessage}
            setShowChat={setShowChat}
            maxLength={maxLength}
          />
        )}
      </div>
    </Fragment>
  );
};

JobStream.propTypes = {
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  getProfileById: PropTypes.func.isRequired,
  jobChatMessage: PropTypes.func.isRequired,
  deleteChatMessage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.profile,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  jobChatMessage,
  deleteChatMessage,
})(JobStream);
